import React, { useState } from "react";
import Layout from "../Layout";
import { FaSyncAlt, FaUpload } from "react-icons/fa";

const weeklyDietData = [
  {
    day: "Day 1 - Monday",
    status: "Active Plan",
    activity: "30 mins walking / Light stretching",
    meals: [
      {
        time: "06:30 AM",
        type: "Early Morning",
        meal: "Warm water with lemon / Soaked almonds (5-6)",
        status: "Pending",
      },
      {
        time: "08:30 AM",
        type: "Breakfast",
        meal: "Idli (2) + Sambar / Vegetable upma",
        status: "Pending",
      },
      {
        time: "11:00 AM",
        type: "Mid-Morning",
        meal: "1 fruit (Apple / Papaya) + Buttermilk",
        status: "Pending",
      },
      {
        time: "01:30 PM",
        type: "Lunch",
        meal: "Brown rice / Chapati (2) + Dal + Vegetable + Curd",
        status: "Pending",
      },
      {
        time: "04:30 PM",
        type: "Evening Snack",
        meal: "Green tea + Roasted chana / Sundal",
        status: "Pending",
      },
      {
        time: "07:30 PM",
        type: "Dinner",
        meal: "Chapati (2) + Vegetable curry / Soup",
        status: "Pending",
      },
      {
        time: "09:30 PM",
        type: "Bedtime",
        meal: "Warm milk / Turmeric milk (optional)",
        status: "Pending",
      },
    ],
  },
  {
    day: "Day 2 - Tuesday",
    status: "Planned",
    activity: "20 mins yoga + 10 mins breathing exercise",
    meals: [
      {
        time: "06:30 AM",
        type: "Early Morning",
        meal: "Warm water + Soaked fenugreek seeds",
        status: "Pending",
      },
      {
        time: "08:30 AM",
        type: "Breakfast",
        meal: "Dosa (2) + Coconut chutney + Sambar",
        status: "Pending",
      },
      {
        time: "11:00 AM",
        type: "Mid-Morning",
        meal: "Guava / Orange + Tender coconut water",
        status: "Pending",
      },
      {
        time: "01:30 PM",
        type: "Lunch",
        meal: "Chapati (2) + Mixed veg curry + Dal + Salad",
        status: "Pending",
      },
      {
        time: "04:30 PM",
        type: "Evening Snack",
        meal: "Herbal tea + Roasted peanuts",
        status: "Pending",
      },
      {
        time: "07:30 PM",
        type: "Dinner",
        meal: "Vegetable soup + Paneer / Tofu salad",
        status: "Pending",
      },
      {
        time: "09:30 PM",
        type: "Bedtime",
        meal: "Warm milk (optional)",
        status: "Pending",
      },
    ],
  },
  {
    day: "Day 3 - Wednesday",
    status: "Planned",
    activity: "30 mins brisk walking",
    meals: [
      {
        time: "06:30 AM",
        type: "Early Morning",
        meal: "Warm water + 5 soaked almonds",
        status: "Pending",
      },
      {
        time: "08:30 AM",
        type: "Breakfast",
        meal: "Oats porridge + Banana slices",
        status: "Pending",
      },
      {
        time: "11:00 AM",
        type: "Mid-Morning",
        meal: "Papaya bowl + Buttermilk",
        status: "Pending",
      },
      {
        time: "01:30 PM",
        type: "Lunch",
        meal: "Rice + Sambar + Beans poriyal + Curd",
        status: "Pending",
      },
      {
        time: "04:30 PM",
        type: "Evening Snack",
        meal: "Green tea + Sprouts salad",
        status: "Pending",
      },
      {
        time: "07:30 PM",
        type: "Dinner",
        meal: "Chapati (2) + Dal + Cucumber salad",
        status: "Pending",
      },
      {
        time: "09:30 PM",
        type: "Bedtime",
        meal: "Turmeric milk (optional)",
        status: "Pending",
      },
    ],
  },
  {
    day: "Day 4 - Thursday",
    status: "Planned",
    activity: "15 mins cycling + 15 mins stretching",
    meals: [
      {
        time: "06:30 AM",
        type: "Early Morning",
        meal: "Jeera water + Soaked raisins",
        status: "Pending",
      },
      {
        time: "08:30 AM",
        type: "Breakfast",
        meal: "Pongal + Sambar / Vegetable poha",
        status: "Pending",
      },
      {
        time: "11:00 AM",
        type: "Mid-Morning",
        meal: "Apple + Lemon water",
        status: "Pending",
      },
      {
        time: "01:30 PM",
        type: "Lunch",
        meal: "Millet rice + Dal + Vegetable kootu + Salad",
        status: "Pending",
      },
      {
        time: "04:30 PM",
        type: "Evening Snack",
        meal: "Buttermilk + Roasted makhana",
        status: "Pending",
      },
      {
        time: "07:30 PM",
        type: "Dinner",
        meal: "Dosa (2) + Tomato chutney + Sambar",
        status: "Pending",
      },
      {
        time: "09:30 PM",
        type: "Bedtime",
        meal: "Warm milk (optional)",
        status: "Pending",
      },
    ],
  },
  {
    day: "Day 5 - Friday",
    status: "Planned",
    activity: "30 mins walking",
    meals: [
      {
        time: "06:30 AM",
        type: "Early Morning",
        meal: "Warm water with lemon + Chia seeds",
        status: "Pending",
      },
      {
        time: "08:30 AM",
        type: "Breakfast",
        meal: "Ragi dosa + Sambar",
        status: "Pending",
      },
      {
        time: "11:00 AM",
        type: "Mid-Morning",
        meal: "Watermelon / Muskmelon bowl",
        status: "Pending",
      },
      {
        time: "01:30 PM",
        type: "Lunch",
        meal: "Chapati (2) + Channa masala + Salad",
        status: "Pending",
      },
      {
        time: "04:30 PM",
        type: "Evening Snack",
        meal: "Green tea + Boiled corn",
        status: "Pending",
      },
      {
        time: "07:30 PM",
        type: "Dinner",
        meal: "Vegetable kichadi + Curd",
        status: "Pending",
      },
      {
        time: "09:30 PM",
        type: "Bedtime",
        meal: "Warm milk / Herbal drink",
        status: "Pending",
      },
    ],
  },
  {
    day: "Day 6 - Saturday",
    status: "Planned",
    activity: "20 mins walk + light body stretches",
    meals: [
      {
        time: "06:30 AM",
        type: "Early Morning",
        meal: "Cinnamon water + Soaked almonds",
        status: "Pending",
      },
      {
        time: "08:30 AM",
        type: "Breakfast",
        meal: "Idiyappam + Vegetable kurma",
        status: "Pending",
      },
      {
        time: "11:00 AM",
        type: "Mid-Morning",
        meal: "Pear / Apple + Buttermilk",
        status: "Pending",
      },
      {
        time: "01:30 PM",
        type: "Lunch",
        meal: "Rice + Rasam + Poriyal + Curd",
        status: "Pending",
      },
      {
        time: "04:30 PM",
        type: "Evening Snack",
        meal: "Tea without sugar + Sundal",
        status: "Pending",
      },
      {
        time: "07:30 PM",
        type: "Dinner",
        meal: "Chapati (2) + Mixed veg gravy",
        status: "Pending",
      },
      {
        time: "09:30 PM",
        type: "Bedtime",
        meal: "Turmeric milk (optional)",
        status: "Pending",
      },
    ],
  },
  {
    day: "Day 7 - Sunday",
    status: "Planned",
    activity: "Rest day / 20 mins slow walk",
    meals: [
      {
        time: "06:30 AM",
        type: "Early Morning",
        meal: "Warm water + Dates (1-2)",
        status: "Pending",
      },
      {
        time: "08:30 AM",
        type: "Breakfast",
        meal: "Vegetable uthappam + Sambar",
        status: "Pending",
      },
      {
        time: "11:00 AM",
        type: "Mid-Morning",
        meal: "Fruit salad + Tender coconut water",
        status: "Pending",
      },
      {
        time: "01:30 PM",
        type: "Lunch",
        meal: "Vegetable biryani small portion + Raita + Salad",
        status: "Pending",
      },
      {
        time: "04:30 PM",
        type: "Evening Snack",
        meal: "Herbal tea + Roasted chana",
        status: "Pending",
      },
      {
        time: "07:30 PM",
        type: "Dinner",
        meal: "Soup + Chapati (1-2) + Veg curry",
        status: "Pending",
      },
      {
        time: "09:30 PM",
        type: "Bedtime",
        meal: "Warm milk (optional)",
        status: "Pending",
      },
    ],
  },
];

function DietPlan() {
  const [selectedDayIndex, setSelectedDayIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const selectedDay = weeklyDietData[selectedDayIndex];

  return (
    <Layout>
      <div className="w-[80%] sm:w-full mx-auto p-5">
        <div className="flex sm:flex-col items-center justify-between">
          <p className="text-lg font-semibold font-opensans text-teal-900">
            Diet Chart Plan
          </p>

          <select
            value={selectedDayIndex}
            onChange={(e) => setSelectedDayIndex(Number(e.target.value))}
            className="border border-gray-300 rounded-lg px-4 py-2 text-sm outline-none focus:ring-1 focus:ring-[#0CB8A1]"
          >
            {weeklyDietData.map((dayItem, index) => (
              <option key={index} value={index}>
                {dayItem.day}
              </option>
            ))}
          </select>
        </div>

        <div className="flex-1 overflow-y-auto scrollwidth p-2 mt-3">
          <div className="w-full bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
            <div className="flex items-center justify-between px-5 py-2 bg-emerald-50 border-b border-emerald-100">
              <div>
                <h2 className="text-lg font-semibold text-emerald-900">
                  {selectedDay.day}
                </h2>
                <p className="text-xs text-gray-500 mt-1">
                  Daily diet plan and completion status
                </p>
              </div>
            </div>

            {/* ── Desktop Table View ── */}
            {!isMobile && (
              <div className="overflow-x-auto">
                <table className="w-full table-fixed text-sm border-collapse">
                  <colgroup>
                    <col className="w-[130px]" />
                    <col className="w-[180px]" />
                    <col />
                    <col className="w-[150px]" />
                    <col className="w-[130px]" />
                  </colgroup>

                  <thead>
                    <tr className="bg-gray-50 text-gray-600 border-b">
                      <th className="px-4 py-3 text-left font-semibold">Time</th>
                      <th className="px-4 py-3 text-left font-semibold">Meal Type</th>
                      <th className="px-4 py-3 text-left font-semibold">Meal</th>
                      <th className="px-4 py-3 text-center font-semibold">Status</th>
                      <th className="px-4 py-3 text-center font-semibold">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {selectedDay.meals.map((item, index) => (
                      <tr
                        key={index}
                        className="border-b last:border-b-0 hover:bg-emerald-50/40"
                      >
                        <td className="px-4 py-3 font-medium text-gray-800">{item.time}</td>

                        <td className="px-4 py-3">
                          <span className="inline-flex rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700">
                            {item.type}
                          </span>
                        </td>

                        <td className="px-4 py-3 text-gray-700">{item.meal}</td>

                        <td className="px-4 py-3 text-center">
                          <select
                            defaultValue={item.status}
                            className="border rounded-lg px-2 py-1 text-xs outline-none focus:ring-1 focus:ring-[#0CB8A1]"
                          >
                            <option>Pending</option>
                            <option>Done</option>
                            <option>Skipped</option>
                          </select>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex justify-center items-center gap-3">
                            <label className="cursor-pointer w-9 h-9 rounded-full bg-[#0CB8A1] text-white flex items-center justify-center hover:scale-105 duration-200">
                              <FaUpload className="text-sm" />
                              <input type="file" className="hidden" />
                            </label>
                          </div>
                        </td>
                      </tr>
                    ))}

                    <tr className="bg-teal-50 border-t border-teal-100">
                      <td className="px-4 py-4 font-semibold text-teal-900">Physical Activity</td>
                      <td></td>
                      <td className="px-4 py-4 text-gray-700">{selectedDay.activity}</td>
                      <td className="px-4 py-4 text-center">
                        <select
                          defaultValue="Pending"
                          className="border rounded-lg px-3 py-2 text-xs outline-none focus:ring-1 focus:ring-[#0CB8A1]"
                        >
                          <option>Pending</option>
                          <option>Done</option>
                          <option>Skipped</option>
                        </select>
                      </td>
                      <td className="px-4 py-4 text-center">
                        <button className="bg-[#0CB8A1] hover:bg-[#089488] text-white px-4 py-2 rounded-lg text-xs font-semibold">
                          Save
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {/* ── Mobile Card View ── */}
            {isMobile && (
              <div className="flex flex-col gap-3 p-3">
                {selectedDay.meals.map((item, index) => (
                  <div
                    key={index}
                    className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden"
                  >
                    <div className="flex items-center justify-between px-4 py-2 bg-emerald-50 border-b border-emerald-100">
                      <span className="text-xs font-semibold text-emerald-800">{item.time}</span>
                      <span className="inline-flex rounded-full bg-white border border-emerald-200 px-3 py-0.5 text-xs font-semibold text-gray-700">
                        {item.type}
                      </span>
                    </div>
                    <div className="px-4 py-3">
                      <p className="text-sm text-gray-700 mb-3">{item.meal}</p>
                      <div className="flex items-center justify-between">
                        <select
                          defaultValue={item.status}
                          className="border rounded-lg px-2 py-1.5 text-xs outline-none focus:ring-1 focus:ring-[#0CB8A1] bg-white"
                        >
                          <option>Pending</option>
                          <option>Done</option>
                          <option>Skipped</option>
                        </select>
                        <label className="cursor-pointer w-9 h-9 rounded-full bg-[#0CB8A1] text-white flex items-center justify-center hover:scale-105 duration-200">
                          <FaUpload className="text-sm" />
                          <input type="file" className="hidden" />
                        </label>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Physical Activity Card */}
                <div className="rounded-xl border border-teal-200 bg-teal-50 shadow-sm overflow-hidden">
                  <div className="px-4 py-2 bg-teal-100 border-b border-teal-200">
                    <span className="text-xs font-semibold text-teal-900">🏃 Physical Activity</span>
                  </div>
                  <div className="px-4 py-3">
                    <p className="text-sm text-gray-700 mb-3">{selectedDay.activity}</p>
                    <div className="flex items-center justify-between">
                      <select
                        defaultValue="Pending"
                        className="border rounded-lg px-2 py-1.5 text-xs outline-none focus:ring-1 focus:ring-[#0CB8A1] bg-white"
                      >
                        <option>Pending</option>
                        <option>Done</option>
                        <option>Skipped</option>
                      </select>
                      <button className="bg-[#0CB8A1] hover:bg-[#089488] text-white px-4 py-2 rounded-lg text-xs font-semibold">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </Layout>
  );
}

export default DietPlan;
